import { Icon } from './Icon';

/** Реестр досье: люди. Геометрия взята из макета «нет доступа». */
export function UsersIcon({ size }: { size?: number }) {
  return (
    <Icon size={size}>
      <circle cx="5.4" cy="4.7" r="2.2" />
      <path d="M1.9 11.8c0-2.1 1.6-3.3 3.6-3.3s3.6 1.2 3.6 3.3" />
      <path d="M9.8 3.4a2 2 0 0 1 0 3.9" />
    </Icon>
  );
}
